import type { DocumentData } from "firebase/firestore";
import { ModuleType } from "../../../templates/types";
import BaseApi from "../../core/BaseApi";
import CalendarModuleModel from "../Calendar/CalendarModuleModel";
import CheckboxModuleModel from "../CheckboxModule/CheckboxModuleModel";
import DateDueModuleModel from "../DateDueModule/DateDueModuleModel";
import ExpenseModuleModel2 from "../ExpenseModule/ExpenseModuleModel";
import InfoModuleModel from "../InfoModule/InfoModel";
import LocationModuleModel from "../Location/LocationModuleModel";
import PlanInfoModuleModel from "../PlanInfoModule/PlanInfoModuleModel";
import PollModuleModel from "../PollModule/PollModuleModel";
import ReminderModuleModel from "../Reminder/ReminderModuleModel";
import RsvpModuleModel from "../RsvpModule/RsvpModuleModel";
import TrackerModuleModel from "../TrackerModule/TrackerModuleModel";
import type BaseModuleModel from "./BaseModuleModel";
import type { ModuleModelData, Snapshot } from "./BaseModuleModel";

type Data = BaseModuleModel<Snapshot, ModuleModelData<Snapshot>>;

export default class ModulesApi extends BaseApi<Data, ModuleModelData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}modules`;
  }

  get store() {
    return this.stores.modulesStore;
  }

  fromFirestore(res: DocumentData): Data {
    const data = res.data();

    if (data.type === ModuleType.Info) {
      return new InfoModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Checkboxes) {
      return new CheckboxModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.PlanInfo) {
      return new PlanInfoModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Calendar) {
      return new CalendarModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Poll) {
      return new PollModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.DateDue) {
      return new DateDueModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Location) {
      return new LocationModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Expense) {
      return new ExpenseModuleModel2(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Tracker) {
      return new TrackerModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Rsvp) {
      return new RsvpModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === ModuleType.Reminder) {
      return new ReminderModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    throw Error(`Tried to create invalid module with type ${data.type}`);

    /*return new ModuleModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });*/
  }
}
